/* -------------------------- */
/* Theme custom JavaScript.   */
/* -------------------------- */

!function($) {

    // Document ready
    $(function() {

        // Only call these functions on product page
        if ( $('html').hasClass('template-product') ){

            // Re-arrange product info to tabs on product page
            productTabs();

            // Show and hide product pictures
            toggleProductPictures(); 

            // Show and hide variant inventory
            toggleVariantInventory();

            // Show and hide pickup order form
            togglePickupOrderForm();

            // Send pickup order form and wait for an answer
            processPickupOrderForm();

            // Force user to first select size. See also template-product.js and component-product-form.js
            productSizeChanges(); 

        }

      // SMS Consent Form
      smsConsentForm();

      // Remove the hero element if it is empty on collection page
      var firstChild = $('.template-collection #MainContent').children().first();
      if (firstChild.length && $.trim(firstChild.html()) === '' && firstChild.prop('id').indexOf('hero') !== -1) {
          firstChild.remove();
          console.log('Empty element removed.');
      } 

      // Remove footer newsletter form if it is already inserted on the page
      if ( $('#MainContent .newsletter').length > 0 ) {
        $('.shopify-section-group-footer-group').children('.newsletter-section').parent().remove();
      }

      // Send cart details to custobar on add to cart event
      // https://www.custobar.com/docs/api/events/
      $(document).on('ajaxProduct:added', async function() {
      
          let customerId = __st.cid;
          let productId = $('form[action="/cart/add"]').find('input[name="id"]').val();
          let url = 'https://halti.fi/cart/';
          
          const cart = await getCart();

          if (cart.items.length > 0) {

            let productIds = []; 
              
            cart.items.forEach( (item, i) => {
              
                url += item.id;
                url += ':';
                url += item.quantity
    
                if ( i + 1 !== cart.items.length ) {
                    url += ',';
                }

                productIds.push(item.id.toString());
                  
            });
      
              window.cstbr.push({
                  'type': 'BASKET_ADD',
                  'customer': customerId, 
                  'product_id': productId,
                  'product_ids': productIds,
                  '42m67__cart_url': url
              });
      
          }

      });

    });


    // Functions
    async function getCart() {
        try {
            const res = await fetch(Shopify.routes.root + 'cart.js');
            const data = await res.json(); 
            return data; 
        } catch (err) {
            console.error('Error getting cart: ' + err);
        }
    }

    function smsConsentForm() {
  
      $('#sms-consent-form').submit(function (e) {
  
      e.preventDefault(); 
      const data = $('#sms-consent-form').serialize();
    
      fetch('https://halti-sms-consent.konsepto.fi/app.php', {
        method: 'POST',
        body: data, 
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(response => response.text())
      .then(response => {
          if (response == 1) {
            $('.sms-consent-done').removeClass('hidden');
          } else {
              $('.sms-consent-error').removeClass('hidden');
          }
        })
        .catch(error => {
          console.log(error);
          $('.sms-consent-error').removeClass('hidden');
        })
      });
      
    }

    function productTabs() {
    
      // Create variables for tabs content
      $features = $('.tabs-content #tab1').children();
      $materials = $('.tabs-content #tab2').children();
      $size = $('.tabs-content #tab3').children();
      
      // Some products don't have instructions
      if ( $('.tabs-content #tab4').length > 0 ) {
          $instructions = $('.tabs-content #tab4').children();
          $('.tab-instructions .tab-content__inner').append($instructions);
      } else {
          $('.tab-instructions').remove();
      }
      
      // Add content to new tabs
      $('.tab-features .tab-content__inner').append($features);
      $('.tab-materials .tab-content__inner').append($materials);
      $('.tab-size .tab-content__inner').append($size);

      // Remove description header
      $('.product__description h2').remove();
      
      // Description as tab is optionary 
      if ( $('.tab-description').length > 0 ) {

          // Create description tab from rest of the content
          $description = $('.product__description').children().not('.tabs,.tabs-content,h2');
          $('.tab-description .tab-content__inner').append($description);
          $('.product__description').remove();
        
      } else {
          $('.product__description .tabs, .product__description .tabs-content').remove();
          $('.product__description').removeClass('hidden');
      }
      
      // Add heights for tabs and collapse them
      $('.tab-content').each( function() {
          var height = $(this).outerHeight();
          $(this).data('height', height);
          $(this).css('height', 0);
      });
      
      // Show and hide tabs content on click. 
      $('.description-tabs .tab h3').click( function() {
      
          var $currentTab = $(this).parent();
          
          if ($currentTab.hasClass('active')) {
              $currentTab.toggleClass('active').find('.tab-content').css('height', 0);
          } else {
              var height = $currentTab.find('.tab-content').data('height');
              $currentTab.toggleClass('active').find('.tab-content').css('height', height + 'px');
          }
      
      });
  
    }

    function toggleProductPictures() {

      // jQuery objects
      $picturesButton = $('.gridy-slider.product-media-slider #show-product-pictures');
      $productMedia = $('.gridy-slider.product-media-slider .product-media:nth-child(n+5)');
      
      // Event handler for pictures button clicks
      $picturesButton.click(function() {

        // Show additional pictures if they are hidden
        if ( $picturesButton.text() == 'Näytä lisää' ) {
          $picturesButton.text('Näytä vähemmän');
          $('gridy-slider .button-container').addClass('active');
          $productMedia.addClass('visible');
        } else {
          // Hide additional pictures if they are visible
          $productMedia.removeClass('visible');
          $picturesButton.text('Näytä lisää');
          $('gridy-slider .button-container').removeClass('active');
          let rect = $('gridy-slider')[0].getBoundingClientRect();
          window.scroll('',rect.y);
        }
        
      });

      // Event handler for color change
      $('variant-radios fieldset[data-option="Color"] input[type="radio"]:nth-of-type(n+2)').click(function() {

          // Show additional pictures if picture for active color is hidden
          const activeColor = $(this).val().split(' ')[0]; 
          const activeColorIsHidden = $('.gridy-slider.product-media-slider .product-media').slice(0,4).find('img').toArray().some(img => 
            $(img).attr('srcset') && !$(img).attr('srcset').includes(activeColor)
          );

          if ( activeColorIsHidden ) {
            $picturesButton.text('Näytä vähemmän');
            $productMedia.addClass('visible');
            setTimeout(function() {
              $('gridy-slider .button-container').addClass('active');
            }, 500);
          }
        
      });

   
      
    }
    
    function toggleVariantInventory() {

      // Move product inventory after the main area wrapper
      $('.product-inventory').insertAfter('#MainContent');

      // Event for user variant change
      document.addEventListener('variant-changed', function(e) {

        // If pickup order form is shown, close it and show inventory
        if ( $('.pickup-order').is(':visible') ) {
            $('.pickup-order').hide();
            $('.store-availability').show();
        }
        
        // Get the new variant id
        var variantId = e.detail.variants.currentVariant.id; 
    
        // Attach current variant to order-form
        $('.pickup-order #reservation #variant-id').val(variantId);
    
        // Show stock if variant data id matches, else hide. 
        $('.variant-stock').each(function() { 
        
          if ($(this).data('variant') == variantId) { 
              $(this).show();
          } else {
              $(this).hide();
          }
        
        });  
    
        // If variant is sold out in pickup locations, disable button 
        if ( $('.variant-stock:visible .locations').children().length == 0 )  {
            $('.show-inventory.btn').prop('disabled',true).text('Ei saatavilla myymälästä');
        } else {
            $('.show-inventory.btn').prop('disabled',false).text('Myymäläsaatavuus');
        }
       
      });
    
      // Inventory button click event
      $('.show-inventory').click( function() {

          // Get default size data-attribute from variant-radios
          const hasDefaultSize = document.querySelector('variant-radios').getAttribute('data-default-size');
      
          // Force user to first select size
          if (hasDefaultSize == 'true') {
            $('product-form')[0].handleErrorMessage('Valitse ensin koko');
            return;
          } 
  
          // Show inventory and main content half width 
          if( !$(this).hasClass('active') ) {
            $(this).addClass('active');
            $('body').addClass('half-width');
            $('#PageContainer').addClass('half-width');
            $('.product-inventory').addClass('active');
            $('.product-inventory .inventory-title').attr('tabindex','0').focus(); 
          } else {
            // Hide inventory and show full main content 
            $(this).removeClass('active');
            $('body').removeClass('half-width');
            $('#PageContainer').removeClass('half-width');
            $('.product-inventory').removeClass('active'); 
          }
      
      });
  
      // Close inventory button click event
      $('.close-inventory').click(function() {
          $('.show-inventory').removeClass('active');
          $('body').removeClass('half-width');
          $('#PageContainer').removeClass('half-width');
          $('.product-inventory').removeClass('active');
          $('#product-title').attr('tabindex','0').focus();
      });
        
    }
    
    function togglePickupOrderForm() {

    // Order pickup button click event
    $('.product-inventory .order-pickup').click( function() {    

        // Get pickup location handle and attach to order form
        var pickupLocation = $(this).parent().data('location');
        $('.pickup-order #reservation #location').val(pickupLocation);

        // Attach pickup location nicename to order details
        var pickupLocationNiceName = pickupNames(pickupLocation);
        $('.order-details .pickup-location').text(pickupLocationNiceName);

        // Attach language to order form
        var currentLang = $('html').attr('lang');
        $('.pickup-order #reservation #language').val(currentLang);

        // Get url and product handle
        var url = window.location.href;
        var productHandle = url.split('/').pop().split('?')[0];

        // Get product details using Ajax API
        $.ajax({
    
        type: 'GET',
        dataType: 'json',
        url: '/products/' + productHandle + '.js',
    
        success: function(data) {

            var product = data;

            // Use default variant id if url doesn't have variant id parameter
            if (url.indexOf('variant=') == -1)
            {
            var variantId = defaultVariantId;
            }
            else {
            var variantId = window.location.search.split('variant=')[1];
            }

            // If variant id matches, then it's the selected one.  
            for (i = 0; i < product.variants.length; i++) {
                if (product.variants[i].id == variantId) {
                    var currentVariant = product.variants[i];
                }
            }

            // Variant details
            var variantImg = currentVariant.featured_image.src;
            var variantTitle = currentVariant.title;
            var variantPrice = currentVariant.price;
            var variantDisplayPrice = variantPrice / 100 + " €";

            // Attach variant details before order form
            $('.order-details .variant-picture').prop('src', variantImg);
            $('.order-details .variant-title').text(variantTitle);
            $('.order-details .variant-price').text(variantDisplayPrice);

            // Attach price to order form
            $('.pickup-order #reservation #price').val(variantPrice);

        },
        error: function(status) {
            console.warn( 'ERROR:', status );
        }
        });
    
        // Show order form and hide inventory
        $('.store-availability').hide();
        $('.product-inventory .pickup-order').css('display','inline');

        // Focus screen reader
        $('.pickup-title').attr('tabindex','0').focus(); 

    });

    // Close pickup order button click event
    $('.product-inventory .close-pickup-order').click( function() {

        // Hide form and show current variant inventory 
        $('.product-inventory .pickup-order').hide();
        $('.store-availability').show();
        $('.product-inventory .inventory-title').attr('tabindex','0').focus(); 

    });

    }
    
    function pickupNames(location) {

        switch (location) {

            case 'outlet-lauttasaari':
            return 'Halti Outlet Lauttasaari';
            break;

            case 'outlet-herttoniemi':
            return 'Halti Outlet Herttoniemi';
            break;

            case 'flamingo':
            return 'Halti Jumbo';
            break;

            case 'halti-mylly':
            return 'Halti Mylly';
            break;

            case 'helsinki-store':
            return 'Halti Helsinki Store';
            break;

            case 'stockmann-helsinki':
            return 'Halti Stockmann Helsinki';
            break;

            case 'halti-tampere':
            return 'Halti Tampere';
            break;

            case 'helsinki-outlet':
            return 'Halti Helsinki Outlet';
            break;

            case 'iso-omena':
            return 'Halti Iso Omena';
            break;


            default: 
            break;

        }

    }
    
    function processPickupOrderForm() {

        // Variable to hold request
        var request;

        // Bind to the submit event of our form
        $("#reservation").submit(function(event){
            
            // Prevent default posting of form - put here to work in case of errors
            event.preventDefault();

            // Abort any pending request
            if (request) {
                request.abort();
            }
            
            // setup some local variables
            var $form = $(this);

            // Let's select and cache all the fields
            var $inputs = $form.find("input, select, button, textarea");

            // Serialize the data in the form
            var serializedData = $form.serialize();

            // Let's disable the inputs for the duration of the Ajax request.
            // Note: we disable elements AFTER the form data has been serialized.
            // Disabled form elements will not be serialized.
            $inputs.prop("disabled", true);

            // Fire off the request to our app
            request = $.ajax({
                url: "https://halti-pickup-order.konsepto.fi/server.php",
                type: "post",
                data: serializedData
            });
            
            // Callback handler that will be called on success
            request.done(function (response, textStatus, jqXHR) {

                // Show order success heading and message. 
                // Hide pickup title, order details and form. 
                $('.pickup-title').hide();
                $('.order-details').hide();
                $('.order-success').removeClass('hidden');
                $('#reservation').hide();
            
                // Log a message to the console
                var obj = JSON.parse(response);
                //console.log(obj);
                console.log("Order " + obj.name + " created");

            });

            // Callback handler that will be called on failure
            request.fail(function (jqXHR, textStatus, errorThrown) {
            
                // Show order failure heading and message. 
                // Hide pickup title, order details and form. 
                $('.pickup-title').hide();
                $('.order-details').hide();
                $('.order-failure').removeClass('hidden');
                $('#reservation').hide();
                
                // Log the error to the console
                console.error(
                    "The following error occurred: "+
                    textStatus, errorThrown
                );

            });

            // Callback handler that will be called regardless
            // if the request failed or succeeded
            request.always(function () {
                // Re-enable the inputs
                $inputs.prop("disabled", false);
            });

        });

    }

    function productSizeChanges() {

      // Click event handler for size radio inputs
      $(document).on('click', 'variant-radios input[name="Koko"]', function () {

        // If default size is in use, set 
        if (this.checked == true) {
          $('fieldset[data-option="Koko"] legend strong').text($(this).val());
        }

        // Set default size data attribute to false as user has now selected a size
        document.querySelector('variant-radios').setAttribute('data-default-size','false');

        // If size error is visible, hide it
        if ($('.product-form__error-message-wrapper').is(':visible') && $('.product-form__error-message').text() == 'Valitse ensin koko') {
          $('product-form')[0].handleErrorMessage();
        }

      });

    }

}(jQuery);